import React, { useEffect, useState } from 'react';
import { useParams, Link, Redirect } from 'react-router-dom';
import { OrganizationProvider, useOrganization } from '../../context/OrganizationContext';
import { useUser } from '../../context/UserContext';

const OrganizationPlatformPageContent = () => {
  const { organizationId } = useParams();

  // Redirect to threads page - the org platform page is no longer needed
  return <Redirect to={`/organization/${organizationId}/threads`} />;
};

// Main component that provides the organization context
const OrganizationPlatformPage = () => {
  return (
    <OrganizationProvider>
      <OrganizationPlatformPageContent />
    </OrganizationProvider>
  );
};

export default OrganizationPlatformPage;